import { selectAuthCredentials } from '../selectors/selectors';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../reducers/reducers';
import { dayjs } from '@/extendedDayjs';
import { trySilentRefreshToken } from '../actions/auth';

const SilentRefreshContainer: React.FC = () => {
    const dispatch = useDispatch();
    const tokenExpiry = useSelector((state: RootState) => selectAuthCredentials(state)?.expiry);

    React.useEffect(() => {
        if (tokenExpiry) {
            // subtract a minute from the expiry so we're not bumping right up against the expiry second
            const expiryDate = dayjs.unix(tokenExpiry).subtract(1, 'minute');

            const msUntilExpiry = expiryDate.diff(dayjs());

            const timeoutID = setTimeout(() => {
                dispatch(trySilentRefreshToken());
            }, msUntilExpiry);

            return () => {
                clearTimeout(timeoutID);
            };
        } else {
            return undefined;
        }
    }, [tokenExpiry]);

    return null;
};

export default SilentRefreshContainer;
